'use es6';

import getIn from 'transmute/getIn';
export const getEventValue = getIn(['target', 'value']);